import { App } from 'vue'
import useDragWindowDirective from './drag-window'
import useDragModalDirective from './drag-modal'
import lazyPluginImage from './lazyPlugin'
import permissionPlugin from './permission'

export function useDirectives (app: App): void {
  useDragWindowDirective(app)
}
export function useModalDirectives (app: App): void {
  app.directive('dialogDrag', useDragModalDirective)
}
export function lazyPlugin (app: App): void {
  lazyPluginImage(app)
}
export function usePermissionPlugin (app: App): void {
  permissionPlugin(app)
}
